"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToTopic = exports.unionToTopic = exports.Topic = void 0;
const topic_handle_js_1 = require("../../solarxr-protocol/pub-sub/topic-handle.js");
const topic_id_js_1 = require("../../solarxr-protocol/pub-sub/topic-id.js");
var Topic;
(function (Topic) {
    Topic[Topic["NONE"] = 0] = "NONE";
    Topic[Topic["TopicHandle"] = 1] = "TopicHandle";
    Topic[Topic["TopicId"] = 2] = "TopicId";
})(Topic = exports.Topic || (exports.Topic = {}));
function unionToTopic(type, accessor) {
    switch (Topic[type]) {
        case 'NONE': return null;
        case 'TopicHandle': return accessor(new topic_handle_js_1.TopicHandle());
        case 'TopicId': return accessor(new topic_id_js_1.TopicId());
        default: return null;
    }
}
exports.unionToTopic = unionToTopic;
function unionListToTopic(type, accessor, index) {
    switch (Topic[type]) {
        case 'NONE': return null;
        case 'TopicHandle': return accessor(index, new topic_handle_js_1.TopicHandle());
        case 'TopicId': return accessor(index, new topic_id_js_1.TopicId());
        default: return null;
    }
}
exports.unionListToTopic = unionListToTopic;
